import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import EdicaoTipoMovimentoEstoque from './EdicaoTipoMovimentoEstoque'
import PrimeTable from '../../../components/PrimeTable'

const TipoMovimentoEstoque = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const exclui = useCallback((dados) => {
    metodoPrograma('exclui', { idTipoMovimento: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setDados(null)
    setTela('lista')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela])

  return (
    <Programa codigo="CtrlTipoMovimentoEstoque" ferramentas={ferramentas}>
      {tela === 'opcoes' ? (
        <EdicaoTipoMovimentoEstoque {...{ dados, voltar, setTela }} />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item xs={12}>
              <PrimeTable
                codigo="CtrlTipoMovimentoEstoque"
                action="lista"
                rows={10}
                habSearch
                head={['Nome', 'Tipo', 'Exclusão']}
                line={(item) => [
                  item[1],
                  item[2] === 'S' ? 'Saída' : 'Entrada',
                  item[3],
                ]}
                collumnsDate={[2]}
                onRowSelect={handleClick}
                onDelete={{ index: 2, action: exclui }}
                refresh={refresh}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Programa>
  )
}

export default TipoMovimentoEstoque
